import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DisplayStoreTreePopupService {

  public displayTreePopup$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  display() {
    this.displayTreePopup$.next(true);
  }

  hide() {
    this.displayTreePopup$.next(false);
  }

}
